export default __webpack_public_path__ + "5f664b3c51b607efdb52ba43af5a49d1.png";